import content from "./uiSchemaContent";
import settings from "./uiSchemaSettings";

export default {
    "settings": settings,
    "content": content
}